<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Invoice",
    meta: [{ name: "New Invoice to Client", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "New Invoice",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Invoice",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit",
          sortable: true,
          label: "UNIT",
        },
        {
          key: "price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL PRICE",
        },
        
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      
      // Value from user input for adding position
      data: {
        product: "",
        unit: "",
        quantity: "",
        price: "",
      },
      existingItem: [],
      unitsArr: [],
      SellingPrice:"",

      itemError: "",
      quantityError: "",
      unitError: "",
      priceError: "",
      customerError: "",
      totals: {
        total: "",
        customer: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      editdata: {
        id: "",
        name: "",
        quantity: "",
        price: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapState("invoices", ["TotalCart"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("invoices", [
      "SaveStatus",
      "InvoiceCart",
      "TotalCart",
    ]),
    ...mapGetters("customers", ["Customers", "SaveStatus",]),
    ...mapGetters("auth",["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.InvoiceCart ? this.InvoiceCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    this.totals.total = this.TotalCart;
    // Set the initial number of items
    this.totalRows = this.InvoiceCart ? this.InvoiceCart.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    
   
    
  },
  methods: {
    ...mapActions({
      FetchCart: "invoices/fetchCart",
      FetchItems: "products/fetchProducts",
      FetchCustomers: "customers/fetchCustomers",
      AddCart: "invoices/addToCart",
      DeleteCartItem: "invoices/deleteCart",
      FetchTotal: "invoices/fetchTotCart",
      EditCartItems: "invoices/editCart",
      SaveInvoice: "invoices/saveInvoice",
      
      
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

   
    
    priceCommas(){
      this.data.price = this.thousandSeprator(this.data.price);
    },
    editPriceCommas(){
      this.editdata.price = this.thousandSeprator(this.editdata.price);
    },
    
    assignArr(){
        let selectedPdt = this.Products.filter((product)=>{
            return product.id == this.data.product.split(' ')[0] || product.code == this.data.product;
        })
        this.unitsArr = selectedPdt[0].units;
        this.data.unit = this.unitsArr[0].id;
        this.SellingPrice = selectedPdt[0].selling;        
        this.data.price =  selectedPdt[0].selling;
    },
    assignUnitPrices(){
        let selectedUnit = this.unitsArr.filter((unit)=>{
            return unit.id == this.data.unit;
        })
        this.SellingPrice = selectedUnit[0].selling;        
        this.data.price =  selectedUnit[0].selling;

    },
    

    checkItem() {
      if (this.data.product != "") {
        this.existingItem = this.InvoiceCart.filter((item) => {
          return item.product.id == this.data.product;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.product = "";
      this.data.unit = "";
      this.data.price = "";
      this.data.quantity = "";
      this.SellingPrice = "";  
    },

    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },


    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.price = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.unitError = "";
      this.quantityError = "";
      this.priceError = "";
      this.customerError="";
      
    },

    showEditModal(data) {
      this.editdata.product = data.id;
      this.editdata.name = data.name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.price = this.thousandSeprator(data.price);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
      this.focusProduct();
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
      this.focusProduct();
    },
   
    saveInvoice() {      
  
      if (this.totals.customer == "") {
        this.customerError = "Customer  is required";
        return;
      } else {
        this.customerError = "";
      }
      
      this.SaveInvoice(this.totals);
      // this.focusProduct();
    },
   
    resetCustomerError() {
      this.customerError = "";
    },
    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Purchased is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.data.price == "") {
        this.priceError = "Unit Price Field is required";
        return;
      } else {
        this.priceError = "";
      }
         
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
        this.SellingPrice = "";
      }     
      this.data.product = this.data.product.split(' ')[0];    
      this.AddCart(this.data);
      this.resetData();
      this.focusProduct();
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });
    },

    nextPlease() {
      document.getElementById('input2').focus();
    },

    focusPrice() {
      document.getElementById('input3').focus();
    },

    focusProduct() {
      this.$refs.cartProduct.focus();
    },
  },
  created() {
    this.FetchCustomers();
    this.FetchItems();
    this.FetchCart();
    this.FetchTotal();
    
  },
  updated() {
    this.totals.total = this.TotalCart;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>              
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="InvoiceCart ? InvoiceCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.price
                      ? thousandSeprator(data.item.price * data.item.quantity)
                      : 0
                  }}
                </template>

                <template #cell(price)="data">
                  {{ data.item.price ? thousandSeprator(data.item.price) : 0 }}
                </template>
                

                <template #cell(actions)="data">
                  <b-btn-group>
                    <b-button
                    size="sm"
                    v-if="MyUserPerm.edit_purchase == 1"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                    v-if="MyUserPerm.delete_purchase == 1"
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i></b-button
                  >

                  </b-btn-group>
                  
                </template>
              </b-table>
                
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!InvoiceCart" />
            <div class="row" v-if="TotalCart > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                    >TOTAL:
                    {{
                      TotalCart ? thousandSeprator(TotalCart) : 0
                    }}/=</strong
                  >
                </h4>
              </div>
            </div>

            <b-form v-if="TotalCart > 0" class="mt-3">
              <div class="row mt-4">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Customer <span class="text-danger">*</span></label>
                    <model-list-select
                      :list="Customers ? Customers : []"
                      v-model="totals.customer"
                      option-value="id"
                      option-text="name1"
                      placeholder="Select Customer"
                      @input="resetCustomerError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="customerError">
                    <em>{{ customerError }}</em>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-3">
                    <label>Invoice Date</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                    />
                  </div>
                </div>
                
                
                <div class="col-md-3 mt-4">
                  <b-button variant="primary" class="float-end"
                    v-if="SaveStatus" disabled><i class="fa fa-check"></i> Save Invoice
                    <b-spinner                      
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                  <b-button v-else variant="primary" class="float-end" @click="saveInvoice()"
                    ><i class="fa fa-check"></i> Save Invoice 
                  </b-button>                  
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">

              <div class="form-group mb-3">
                <label>Product <span class="text-danger">*</span></label>
                <input
                  id="input1"
                  class="form-control"
                  v-model="data.product"
                  ref="cartProduct"
                  list="products"
                  placeholder="Select Product or Enter Barcode"
                  @input="resetErrors()"
                  @change="assignArr(), checkItem()"
                  @keyup.enter="nextPlease()"
                />
                <datalist id="products">
                <option
                    v-for="(pdt, p) in Products"
                    :value="pdt.name3"
                    :key="p"
                >
                </option>
                </datalist>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="row">
                  <h4 class="text-primary text-center" v-if="SellingPrice">Selling Price: {{ thousandSeprator(SellingPrice) }}</h4>
              </div>
              <div class="row">
                  <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label>Quantity <span class="text-danger">*</span></label>
                        <input
                        id="input2"
                        type="number"
                        class="form-control"
                        step="any"
                        v-model="data.quantity"
                        @input="resetErrors()"
                        @keyup.enter="focusPrice()"
                        placeholder="Enter Quantity"
                        />
                        <div class="text-danger" v-if="quantityError">
                        <em>{{ quantityError }}</em>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label>Unit Measure <span class="text-danger">*</span></label>
                        <model-list-select
                        :list="unitsArr ? unitsArr : []"
                        v-model="data.unit"
                        option-value="id"
                        option-text="unitsym"
                        placeholder="Select Unit"
                        @input="resetErrors(), assignUnitPrices()"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="unitError">
                        <em>{{ unitError }}</em>
                        </div>
                    </div>
                  </div>
              </div>
              
              
              <div  class="form-group mb-3">
                <label>Unit Selling Price <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  step="any"
                  id="input4"
                  v-model="data.price"
                  @input="sellingCommas()"
                  placeholder="Enter Unit Selling Price"
                />
              </div>
              
              <div class="form-group text-center">
                <b-button
                  @click="addToCart()"
                  variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title class="text-primary">
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Buying Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.price" @input="editBuyingCommas()"/>
      </div>
      <div class="form-group mb-3">
        <label>Unit Selling Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.unit_sellingprice" @input="editSellingCommas()"/>
      </div>
      
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem">
      <template #modal-title class="text-danger"> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>